
export const EDITORIAL_SOURCE_CODE = 'finanztreff.de';
export const VIDEO_SOURCE_CODE = 'der-aktionaer-tv';
export const BLOG_SOURCE_CODE = 'finanztreff.de-blog';
